import { CommonConstants } from "../../common/constants/common-constants";
import { IAPIResponse, IHTTPResponse } from "../../common/models/httpModels";
import { HTTPService } from "../../common/services/httpService";
import { IOEFileDeleteRequest, IOlympiadExamFile, IOlympiadExamFileRequest } from "./olympiadExamModels";

const httpService = new HTTPService();
const fileUpload = (files: File[], fileRequest: IOlympiadExamFileRequest): Promise<IHTTPResponse<IAPIResponse<any>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.OlympiadExamFileUpload
        }`;
    const formData = new FormData();
    files.forEach((file) => { formData.append('files', file) });

    formData.append('examId', fileRequest.examId.toString());


    return httpService.fileUpload(url, formData);
};

const getFiles = (examId: number): Promise<IHTTPResponse<IAPIResponse<IOlympiadExamFile>>> => {
    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.OlympiadExamFiles}`;

    return httpService.get(url + '/' + examId);
}

const deleteFile = (deleteFileRequest: IOEFileDeleteRequest): Promise<IHTTPResponse<IAPIResponse<IOlympiadExamFile>>> => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.OlympiadExamDeleteFile}`;

    return httpService.post(url, deleteFileRequest);
}

const getFileDownloadUrl = (fileId: number): string => {

    const url = `${CommonConstants.BaseAddress}${CommonConstants.ApiConstants.OlympiadExamDownloadFile}/${fileId}`;

    return url;
}

const OlympiadExamService = {
    fileUpload,
    getFiles,
    deleteFile,
    getFileDownloadUrl
};

export default OlympiadExamService;